/**
 * @generated SignedSource<<b86650ba4876b50d57b47c5a2a661e6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetEmployeeRoleOverviewContent_widgetSubscription$variables = {
  subscriptionKey: string;
};
export type WidgetEmployeeRoleOverviewContent_widgetSubscription$data = {
  readonly widgetEmployeeRoleOverviewContentChanged: {
    readonly roles: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeRoleOverviewListItem_role">;
    }>;
    readonly subscriptionKey: string;
  };
};
export type WidgetEmployeeRoleOverviewContent_widgetSubscription = {
  response: WidgetEmployeeRoleOverviewContent_widgetSubscription$data;
  variables: WidgetEmployeeRoleOverviewContent_widgetSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subscriptionKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "subscriptionKey",
    "variableName": "subscriptionKey"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionKey",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetEmployeeRoleOverviewContent_widgetSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WidgetEmployeeRoleOverviewContentListMedium",
        "kind": "LinkedField",
        "name": "widgetEmployeeRoleOverviewContentChanged",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EmployeeRole",
            "kind": "LinkedField",
            "name": "roles",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetEmployeeRoleOverviewListItem_role"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WidgetEmployeeRoleOverviewContent_widgetSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WidgetEmployeeRoleOverviewContentListMedium",
        "kind": "LinkedField",
        "name": "widgetEmployeeRoleOverviewContentChanged",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EmployeeRole",
            "kind": "LinkedField",
            "name": "roles",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Employee",
                "kind": "LinkedField",
                "name": "employees",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isPublicAndInternalImage"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "publicImageUrl",
                            "storageKey": null
                          }
                        ],
                        "type": "PublicImage",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumbhash",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ImageSize",
                            "kind": "LinkedField",
                            "name": "sizes",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "urlExpiresAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "height",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "width",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "Image",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "workStatus",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2957fdd48b72fc6fb40f7f7e005a42a4",
    "id": null,
    "metadata": {},
    "name": "WidgetEmployeeRoleOverviewContent_widgetSubscription",
    "operationKind": "subscription",
    "text": "subscription WidgetEmployeeRoleOverviewContent_widgetSubscription(\n  $subscriptionKey: String!\n) {\n  widgetEmployeeRoleOverviewContentChanged(subscriptionKey: $subscriptionKey) {\n    subscriptionKey\n    roles {\n      id\n      ...WidgetEmployeeRoleOverviewListItem_role\n    }\n    id\n  }\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment WidgetEmployeeRoleOverviewListItem_role on EmployeeRole {\n  id\n  name\n  team {\n    id\n    name\n    color\n  }\n  employees {\n    id\n    name\n    ...Avatar_employee\n  }\n}\n"
  }
};
})();

(node as any).hash = "d605d121b7bc9d3520b9ae5419e66d1a";

export default node;
